const { createSlice } = require("@reduxjs/toolkit");

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
  },
  reducers: {
    addToCart(state: any, action: any) {
      const product = action.payload;
      
      // Check if there are existing items from different categories in the same event
      const existingEventItems = state.cartItems.filter(
        (item: any) => item.event_id === product.event_id
      );
      
      const existingDifferentCategory = existingEventItems.find(
        (item: any) => item.category_id !== product.category_id
      );
      
      // If there's already a different category in cart for this event, throw error
      if (existingDifferentCategory) {
        throw new Error(`You can only purchase tickets from one category at a time. Please remove "${existingDifferentCategory.category_name}" from your cart first.`);
      }
      
      const cartItem = state.cartItems.find(
        (item: any) => item.category_id === product.category_id
      );
      
      if (!cartItem) {
        const quantityToAdd = product.quantity ? product.quantity : 1;
        state.cartItems.push({
          ...product,
          quantity: quantityToAdd,
        });
      } else {
        state.cartItems = state.cartItems.map((item: any) => {
          if (item.category_id === cartItem.category_id) {
            const quantityToAdd = product.quantity ? product.quantity : 1;
            return {
              ...item,
              quantity: item.quantity + quantityToAdd,
            };
          }
          return item;
        });
      }
    },
    deleteFromCart(state: any, action: any) {
      const category_id = action.payload;
      state.cartItems = state.cartItems.filter(
        (item: any) => item.category_id !== category_id
      );
    },
    decreaseQuantity(state: any, action: any) {
      const product = action.payload;
      const cartItem = state.cartItems.find(
        (item: any) => item.category_id === product.category_id
      );
      if (cartItem) {
        if (cartItem.quantity === 1) {
          state.cartItems = state.cartItems.filter(
            (item: any) => item.category_id !== cartItem.category_id
          );
        } else {
          state.cartItems = state.cartItems.map((item: any) =>
            item.category_id === cartItem.category_id
              ? { ...item, quantity: item.quantity - 1 }
              : item
          );
        }
      }
    },
    deleteAllFromCart(state: any) {
      state.cartItems = [];
    },
    deleteByEventId(state: any, action: any) {
      const event_id = action.payload;
      state.cartItems = state.cartItems.filter(
        (item: any) => item.event_id !== event_id
      );
      console.log(state.cartItems);
    },
  },
});

// Utility function to validate single category per event
export const validateSingleCategory = (cartItems: any[], newItem: any) => {
  const existingEventItems = cartItems.filter(
    (item: any) => item.event_id === newItem.event_id
  );
  
  const existingDifferentCategory = existingEventItems.find(
    (item: any) => item.category_id !== newItem.category_id
  );
  
  if (existingDifferentCategory) {
    throw new Error(
      `You can only purchase tickets from one category at a time. Please remove "${existingDifferentCategory.category_name}" from your cart first.`
    );
  }
  
  return true;
};

// Utility function to filter cart items by event_id
export const filterCartByEventId = (cartItems: any, event_id: string) => {
  const filteredItems = cartItems.filter(
    (item: any) => item.event_id === event_id
  );
  const totalTickets = filteredItems.reduce(
    (sum: any, item: { quantity: any }) => sum + item.quantity,
    0
  );
  const totalPrice = filteredItems.reduce(
    (sum: number, item: { quantity: number; price: number }) =>
      sum + item.quantity * item.price,
    0
  );
  return { filteredItems, totalTickets, totalPrice };
};

export const {
  addToCart,
  deleteFromCart,
  decreaseQuantity,
  deleteAllFromCart,
  deleteByEventId,
} = cartSlice.actions;

export default cartSlice.reducer;
